// Lib
import { FC } from "react";
// Types
import { LoyaltyLogs } from "types/loyalty";
// Icons
import { DescriptionBlackIcon } from "icons";
// Components
import { Table } from "components";

import { columns } from "./config";

interface LoyaltyLogsTabProps {
  isLoading: boolean;
  loyaltyLogsData?: LoyaltyLogs;
}

export const LoyaltyLogsTab: FC<LoyaltyLogsTabProps> = ({
  isLoading,
  loyaltyLogsData,
}) => {
  return (
    <Table
      isLoading={isLoading}
      dataSource={loyaltyLogsData?.logs || []}
      columns={columns}
      empty={{
        icon: DescriptionBlackIcon,
        title: "No referrals to show.",
      }}
      header={{
        totalCount: loyaltyLogsData?.logs?.length,
      }}
    />
  );
};
